export default __webpack_public_path__ + "static/media/step-2.0d5ff727.0d5ff727.jpg";